module.exports = __webpack_public_path__ + "static/media/Акманова С. (НУ).2e4d4cc2.pdf";